<template>
  <header class="site-nav">
    <div class="site-nav-inner">
      <RouterLink class="site-brand" to="/">
        <img
          class="site-brand-logo"
          src="https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.png"
          alt="BV627"
        />
      </RouterLink>

      <nav class="site-links" aria-label="Main navigation">
        <RouterLink class="site-link" to="/">首页</RouterLink>
        <RouterLink class="site-link" to="/library">资源库</RouterLink>
        <RouterLink class="site-link" to="/about">关于</RouterLink>
      </nav>

      <div class="site-dead-actions" aria-label="Disabled utilities">
        <span class="site-pill">没有搜索框</span>
        <button class="site-dead-button" type="button" disabled>搜索没用</button>
        <button class="site-dead-button" type="button" disabled>会员入口锁定</button>
      </div>
    </div>
  </header>
</template>

<style scoped>
.site-nav {
  position: sticky;
  top: 0;
  z-index: 5000;
  padding: 16px 14px 0;
}

.site-nav-inner {
  width: min(1280px, calc(100vw - 8px));
  margin: 0 auto;
  min-height: 78px;
  padding: 14px 18px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  display: flex;
  align-items: center;
  gap: 18px;
  background:
    radial-gradient(circle at left top, rgba(255, 240, 0, 0.16), transparent 22%),
    linear-gradient(135deg, rgba(22, 18, 10, 0.92), rgba(8, 9, 15, 0.94));
  backdrop-filter: blur(18px);
  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.site-brand {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #fff;
}

.site-brand-kicker {
  font-size: 11px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.52);
}

.site-brand-logo {
  display: block;
  width: auto;
  height: 30px;
  object-fit: contain;
  filter:
    drop-shadow(0 0 10px rgba(255, 240, 0, 0.2))
    drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}

.site-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.site-link {
  min-height: 48px;
  padding: 12px 18px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.site-link:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.08);
}

.site-link.router-link-exact-active,
.site-link.router-link-active {
  background: linear-gradient(180deg, #fff790, #fff000);
  color: #1a1300;
  font-weight: 700;
}

.site-dead-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.site-pill {
  min-height: 42px;
  padding: 10px 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  color: #fff000;
  background: rgba(255, 240, 0, 0.08);
  border: 1px solid rgba(255, 240, 0, 0.16);
  font-size: 13px;
}

.site-dead-button {
  min-height: 42px;
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px dashed rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.45);
  cursor: not-allowed;
}

@media (max-width: 980px) {
  .site-nav-inner {
    flex-wrap: wrap;
  }

  .site-dead-actions {
    margin-left: 0;
    justify-content: flex-start;
  }
}

@media (max-width: 720px) {
  .site-nav {
    padding-top: 12px;
  }

  .site-nav-inner {
    padding: 14px;
    border-radius: 22px;
  }

  .site-brand-logo {
    height: 26px;
  }
}
</style>
